import axiosInstance from '@/plugins/axios';

// Tela Horários e jornada (análise) — porte do TrabalhadorJornada[Analise]Service (BFF).
const BASE = 'trabalhador-jornada';

const ServiceHorarios = {
  // Visão geral: dashboard combinado (Etapas + Status + Classificação).
  dashboard: (body) => axiosInstance.post(`${BASE}/analysis/dashboard`, body ?? {}),
  // Risco: exposição ao risco.
  grafico: (body) => axiosInstance.post(`${BASE}/grafico/risco`, body ?? {}),
  // Tabela de trabalhadores (paginada/ordenada/filtrada).
  /** @param {*} body @param {{ page?: number, size?: number, sort?: string }} [opts] */
  list: (body, { page = 0, size = 50, sort } = {}) =>
    axiosInstance.post(BASE, body ?? {}, { params: { page, size, ...(sort ? { sort } : {}) } }),
  // Aba Risco > Todos: trabalhadores com risco detectado.
  /** @param {*} body @param {{ page?: number, size?: number, sort?: string }} [opts] */
  comRiscoTodos: (body, { page = 0, size = 50, sort } = {}) =>
    axiosInstance.post(`${BASE}/com-risco`, body ?? {}, {
      params: { page, size, ...(sort ? { sort } : {}) },
    }),
  // Opções de filtro da listagem (CON-5227): valores distintos existentes no banco, por CNPJ-raiz.
  filters: (rootCnpjList) => axiosInstance.post(`${BASE}/filtros`, rootCnpjList ?? null),
  // Aba Risco: ocorrências (filtro).
  comRiscoFiltros: () => axiosInstance.get(`${BASE}/com-risco/filtros`),
  // Aba Risco > Por ocorrência: agrupado.
  /** @param {*} body @param {{ page?: number, size?: number, sort?: string }} [opts] */
  porOcorrencia: (body, { page = 0, size = 50, sort } = {}) =>
    axiosInstance.post(`${BASE}/com-risco/por-ocorrencia`, body ?? {}, {
      params: { page, size, ...(sort ? { sort } : {}) },
    }),
  // Dialog: trabalhadores de uma ocorrência.
  porOcorrenciaDetalhe: (cnpj, recommendationId, { page = 0, size = 50 } = {}) =>
    axiosInstance.get(`${BASE}/com-risco/por-ocorrencia/detalhe/${cnpj}/${recommendationId}`, {
      params: { page, size },
    }),
  // Dialog Movimentações: histórico de mudanças da análise de um trabalhador.
  // O path usa o id da ANÁLISE (trabalhador_jornada_analise.id), não o do trabalhador.
  movimentacoes: (analiseId, body, { page = 0, size = 100 } = {}) =>
    axiosInstance.post(`${BASE}/analysis/${analiseId}/history`, body ?? {}, {
      params: { page, size },
    }),
  exportMovimentacoes: (analiseId, body) =>
    axiosInstance.post(`${BASE}/${analiseId}/movements/export`, body ?? {}),
  // Exportações: enfileiram um export persistido (report_process) — não retornam mais binário.
  exportList: (body) => axiosInstance.post(`${BASE}/export`, body ?? {}),
  exportComRiscoTodos: (body) => axiosInstance.post(`${BASE}/com-risco/export`, body ?? {}),
  exportPorOcorrencia: (body) =>
    axiosInstance.post(`${BASE}/com-risco/por-ocorrencia/export`, body ?? {}),
  // Export dos trabalhadores de uma ocorrência (dialog do detalhe).
  exportPorOcorrenciaDetalhe: (cnpj, recommendationId) =>
    axiosInstance.post(
      `${BASE}/com-risco/por-ocorrencia/detalhe/export/${cnpj}/${recommendationId}`,
    ),
  // C2 — detalhe da análise + save do analista + options + catálogo de ocorrências.
  getAnaliseDetalhe: (analiseId) => axiosInstance.get(`${BASE}/analysis/${analiseId}`),
  salvarAnalise: (analiseId, payload) =>
    axiosInstance.put(`${BASE}/analysis/${analiseId}/update`, payload),
  optionsWorkRegime: () => axiosInstance.get(`${BASE}/analysis/work-regime/options`),
  optionsJourneyType: () => axiosInstance.get(`${BASE}/analysis/journey-type/options`),
  optionsPartTime: () => axiosInstance.get(`${BASE}/analysis/part-time/options`),
  listarOcorrenciasCatalogo: () =>
    axiosInstance.post('work-schedules/recommendations?page=0&size=500', {}),
  // D — Movimentações: timeline de eventos eSocial de jornada do trabalhador.
  listarEventos: (trabalhadorId, body, { page = 0, size = 50, sort } = {}) =>
    axiosInstance.post(`${BASE}/${trabalhadorId}/eventos`, body ?? {}, {
      params: { page, size, ...(sort ? { sort } : {}) },
    }),
  filtrosEventos: (trabalhadorId) => axiosInstance.get(`${BASE}/${trabalhadorId}/eventos/filtros`),
  exportarEventos: (trabalhadorId, body) =>
    axiosInstance.post(`${BASE}/${trabalhadorId}/eventos/export`, body ?? {}),
};

export default ServiceHorarios;
